import { createApp } from 'vue'
import App from './EnvironmentAir.vue'

createApp(App).mount('#app-environment-air')
